import { useState } from 'react';
import styled, { useTheme } from 'foundations-theming/utils';
import { HorizontalInsertDropTarget, BALL_RADIUS, OUTLINE_DELTA
// @ts-expect-error Untyped module
} from '../InsertDropTargets';
import { SMALL_RESPONSIVE_SIZE } from './constants';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { VENUS_MESOSPHERE_LAYER } from 'foundations-components/transitional/constants';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HoverButtonWrapper = styled.div.withConfig({
  displayName: "HoverButton__HoverButtonWrapper",
  componentId: "sc-1p1rfm8-0"
})([".hs-private.hs-private.hs-private &{position:relative;box-sizing:border-box;width:fit-content;border-radius:", ";padding-inline:", ";padding-block:", ";z-index:", ";cursor:pointer;transition:transform 0.5s;transform:scale(1.000001);color:", ";background-color:", ";}.hs-private.hs-private.hs-private &:hover{background-color:", ";color:", ";transform:scale(1.05);}.hs-private.hs-private.hs-private &:active{background-color:", ";transition:background-color 100ms;}"], props => props.borderRadius, props => props.paddingInline, props => props.paddingBlock, VENUS_MESOSPHERE_LAYER, ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-calypso'], ({
  theme
}) => theme.color['do-not-use-calypso-dark'], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-link-hover']);
const HoverButton = ({
  top,
  left,
  icon,
  onClick,
  responsiveSize,
  borderRadius,
  label,
  useHighlightLine,
  highlightTop = 0,
  highlightLeft = 0,
  highlightWidth = 0,
  testId = 'layout-dnd-hover-button'
}) => {
  const theme = useTheme();
  const shouldRenderWithText = responsiveSize !== SMALL_RESPONSIVE_SIZE && !!label;
  const [hovered, setHovered] = useState(false);
  const offsetWidth = Math.round(highlightWidth - BALL_RADIUS - OUTLINE_DELTA);
  const offsetLeft = Math.round(highlightLeft + BALL_RADIUS / 2);
  const paddingInline = shouldRenderWithText ? theme.space['600'] : theme.space['0'];
  const paddingBlock = shouldRenderWithText ? theme.space['200'] : theme.space['0'];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(HoverButtonWrapper, {
      borderRadius: borderRadius,
      "data-transition-wrapper": true,
      style: {
        top,
        left
      },
      onClick: onClick,
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      "data-test-id": testId,
      paddingInline: paddingInline,
      paddingBlock: paddingBlock,
      children: [icon && /*#__PURE__*/_jsx(IconCircle, {
        icon: icon,
        size: "200",
        borderStyle: "none",
        padding: shouldRenderWithText ? '0' : '300',
        textAlign: "center"
      }), shouldRenderWithText && /*#__PURE__*/_jsx(View, {
        as: "span",
        display: "inline-block",
        position: "relative",
        paddingInlineStart: "50",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          color: "text-core-on-fill-default",
          children: label
        })
      })]
    }), hovered && useHighlightLine && /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
      top: highlightTop,
      left: offsetLeft,
      width: offsetWidth
    })]
  });
};
export default HoverButton;